import { ShowroomTileBadge } from "@faire/deprecated-retailer-visitor-shared/components/Showroom/ShowroomTileBadge";
import { VolumePricingBadge } from "@faire/deprecated-retailer-visitor-shared/components/VolumePricing/VolumePricingBadge";
import { getColor } from "@faire/sdui/lib/getColor";
import { getIcon } from "@faire/sdui/lib/getIcon";
import { IBadge } from "@faire/web-api--source/indigofair/badges/IBadge";
import { IBadgeStyle } from "@faire/web-api--source/indigofair/badges/IBadgeStyle";
import { IFaireIcon } from "@faire/web-api--source/indigofair/data/IFaireIcon";
import { Row } from "@faire/web/slate/Layout";
import { cn } from "@faire/web/tools/cn";
import React from "react";

interface IProps {
  badge: IBadge;
  productToken?: string;
}

export const BadgeGuidepost: React.FC<IProps> = ({ badge, productToken }) => {
  if (!(badge.style?.badge_message && badge.type && badge.display_to_user)) {
    return null;
  }
  switch (badge.type) {
    case IBadge.BadgeType.SHOWROOM:
      return (
        <ShowroomTileBadge
          token={productToken}
          customEventName="product-badge"
          tooltipZIndex={1005}
        />
      );
    case IBadge.BadgeType.VOLUME_PRICING:
      return (
        <VolumePricingBadge
          discountString={badge.style.badge_message}
          className="-top-2"
        />
      );

    default:
      return <Badge className="cursor-pointer" badgeStyle={badge.style} />;
  }
};

const Badge: React.FC<{
  className: string;
  badgeStyle: IBadgeStyle;
}> = ({ className, badgeStyle }) => {
  const { badge_message, icon, alt_text } = badgeStyle;

  return (
    <Row gap={4} align="center">
      {icon ? <BadgeIcon icon={icon} /> : null}
      <Row
        align="center"
        className={cn(
          className,
          "font-fs-label font-medium",
          "truncate",
          "justify-start lg:justify-center",
          "min-h-[22px] w-fit max-w-full min-w-[20px]",
          "px-[3px] py-[3px] lg:px-[7px]",
          "rounded",
          "border-fs-surface-primary border border-solid",
          "bg-fs-surface-primary",
          "text-fs-text-primary",
          "focus-visible:outline-2 focus-visible:outline-solid"
        )}
        tabIndex={0}
        aria-label={alt_text || badge_message}
      >
        {badge_message}
      </Row>
    </Row>
  );
};

const ICON_SIZE = "12px";
const BadgeIcon: React.FC<{
  icon: IFaireIcon;
}> = ({ icon }) => {
  const Icon = getIcon(icon);
  return (
    <Row
      justify="center"
      align="center"
      style={{
        backgroundColor: getColor(icon?.background_color_token),
      }}
      className="min-h-[24px] min-w-[24px] rounded"
    >
      <Icon
        color={getColor(icon?.color_token)}
        width={ICON_SIZE}
        height={ICON_SIZE}
      />
    </Row>
  );
};
